import React from 'react';

import { COLORS } from '../../constants/colors';
import { useFooter } from '../../graphql/hooks/use-footer';
import SvgImage from '../Global/SvgImage';
import Logo from '../Logo/Logo';
import Newsletter from '../Newsletter';

const Footer = () => {
  const {
    copyright,
    emailPlaceholder,
    emailTitle,
    pageLinks,
    socialMediaLinks,
  } = useFooter();

  return (
    <div className="footer" data-module-id="footer" role="contentinfo">
      <div className="footer__content">
        <div className="footer__content--top">
          <div className="logo-wrapper">
            <Logo
              backgroundColor={COLORS.liquorice}
              foregroundColor={COLORS.snow}
              inverse
            />
          </div>
          <div className="newsletter">
            <Newsletter
              full
              inverse
              placeholder={emailPlaceholder}
              title={emailTitle}
            />
          </div>
        </div>
        <div className="footer__content--bottom">
          <div className="footer__content--bottom__page-link">
            {pageLinks.map(({ title, url }) => (
              <a
                key={url}
                data-component-id="footer_content_bottom_link"
                href={url}
                rel="noreferrer"
                target="_blank"
              >
                {title}
              </a>
            ))}
          </div>
          <div className="icons">
            {socialMediaLinks.map(({ icon, title, url }) => {
              return (
                <a
                  key={url}
                  aria-label={title}
                  data-component-id="social_media_links"
                  data-tracking-event="share"
                  data-tracking-method={`social_media_${title}_method`}
                  href={url}
                  rel="noreferrer"
                  target="_blank"
                >
                  <SvgImage alt={title} image={icon} />
                </a>
              );
            })}
          </div>
        </div>
        <div className="footer__content--copyright">{copyright}</div>
      </div>
    </div>
  );
};

export default Footer;
